import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { debounceTime, from, Subscription, switchMap } from 'rxjs';
import { SipService } from '../services/sip.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-device-settings-dialog',
  templateUrl: './device-settings-dialog.component.html',
  styleUrls: ['./device-settings-dialog.component.css'],
})
export class DeviceSettingsDialogComponent
  implements OnInit
{
  microphones: MediaDeviceInfo[] = [];
  speakers: MediaDeviceInfo[] = [];

  selectedMic: any;
  selectedSpeaker: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private sipService: SipService,
    private snack: MatSnackBar
  ) {}

  async ngOnInit() {
    
    this.microphones = this.data.microphones || [];
    this.speakers = this.data.speakers || [];
    this.selectedMic = this.data.selectedMic || null;
    this.selectedSpeaker = this.data.selectedSpeaker || null;
  }
  

  async onMicChange(deviceId: string) {
    await this.sipService.selectMicrophone(deviceId);
  }

  async onSpeakerChange(deviceId: string) {
    await this.sipService.selectSpeaker(deviceId); // ✅ Call sipService method
  }

}
